import { render, staticRenderFns } from "./BoSidebarMenu.vue?vue&type=template&id=4df6d33f"
import script from "./BoSidebarMenu.vue?vue&type=script&lang=js"
export * from "./BoSidebarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports